import React from 'react';

import createSvgIcon from './hoc/createSvgIcon';

export default createSvgIcon(
  () => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 20 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
        d="M20 2V8C20 9.1 19.1 10 18 10H17V8H18V2H2V8H8V10H2C0.9 10 0 9.1 0 8V2C0 0.9 0.9 0 2 0H18C19.1 0 20 0.9 20 2ZM12.5 12L13.59 9.59L16 8.5L13.59 7.41L12.5 5L11.41 7.41L9 8.5L11.41 9.59L12.5 12ZM15 7L15.62 5.62L17 5L15.62 4.38L15 3L14.38 4.38L13 5L14.38 5.62L15 7ZM12.5 12L13.59 9.59L16 8.5L13.59 7.41L12.5 5L11.41 7.41L9 8.5L11.41 9.59L12.5 12ZM15 7L15.62 5.62L17 5L15.62 4.38L15 3L14.38 4.38L13 5L14.38 5.62L15 7Z"
        fill="black"
        fillOpacity="0.6"
      />
    </svg>
  ),
  'Templates',
  '0 0 24 24',
);
